import { toIsoDate, type IsoDate } from '@/lib/isoDate'

interface ExifDateMetadata {
  DateTimeOriginal?: unknown
}

function dateToIso(value: Date): IsoDate | null {
  if (!Number.isFinite(value.getTime())) return null
  const year = String(value.getFullYear()).padStart(4, '0')
  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  return toIsoDate(`${year}-${month}-${day}`)
}

export function isoDateFromExif(value: unknown): IsoDate | null {
  if (value instanceof Date) return dateToIso(value)
  if (typeof value !== 'string') return null
  const match = /^(\d{4})[:-](\d{2})[:-](\d{2})(?:\s|T|$)/.exec(value.trim())
  if (!match) return null
  try {
    return toIsoDate(`${match[1]}-${match[2]}-${match[3]}`)
  } catch {
    return null
  }
}

export async function readExifDate(file: Blob): Promise<IsoDate | null> {
  try {
    const { parse } = await import('exifr')
    const metadata: unknown = await parse(file, ['DateTimeOriginal'])
    if (typeof metadata !== 'object' || metadata === null) return null
    const capturedDate = isoDateFromExif((metadata as ExifDateMetadata).DateTimeOriginal)
    if ((metadata as ExifDateMetadata).DateTimeOriginal !== undefined && capturedDate === null) {
      console.warn('EXIF DateTimeOriginal is present but is not a valid calendar date')
    }
    return capturedDate
  } catch (error) {
    console.warn('Could not read EXIF DateTimeOriginal; continuing without a captured date', error)
    return null
  }
}
